/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AppSagasServerInfoQueryVariables = {};
export type AppSagasServerInfoQueryResponse = {
    readonly system: {
        readonly serverVersion: string;
    } | null;
    readonly mandant: {
        readonly mandantId: string;
        readonly logo: string | null;
        readonly abasId: number;
        readonly jasperHeader: string | null;
        readonly jasperFooter: string | null;
        readonly ownercode: string | null;
        readonly modules: ReadonlyArray<{
            readonly enabled: boolean;
            readonly name: string;
        } | null> | null;
        readonly openRemarkPopupInContract: boolean | null;
    } | null;
};
export type AppSagasServerInfoQuery = {
    readonly response: AppSagasServerInfoQueryResponse;
    readonly variables: AppSagasServerInfoQueryVariables;
};



/*
query AppSagasServerInfoQuery {
  system {
    serverVersion
  }
  mandant {
    mandantId
    logo
    abasId
    jasperHeader
    jasperFooter
    ownercode
    modules {
      enabled
      name
    }
    openRemarkPopupInContract
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "System",
    "kind": "LinkedField",
    "name": "system",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serverVersion",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Mandant",
    "kind": "LinkedField",
    "name": "mandant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mandantId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abasId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jasperHeader",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jasperFooter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownercode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Module",
        "kind": "LinkedField",
        "name": "modules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "openRemarkPopupInContract",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppSagasServerInfoQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSagasServerInfoQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "8f80d98bcf079b66d5c33418aa9a5efc",
    "id": null,
    "metadata": {},
    "name": "AppSagasServerInfoQuery",
    "operationKind": "query",
    "text": "query AppSagasServerInfoQuery {\n  system {\n    serverVersion\n  }\n  mandant {\n    mandantId\n    logo\n    abasId\n    jasperHeader\n    jasperFooter\n    ownercode\n    modules {\n      enabled\n      name\n    }\n    openRemarkPopupInContract\n  }\n}\n"
  }
};
})();
(node as any).hash = '608a45ac1e3a79817b30838e409fb1a6';
export default node;
